import { VOY_TOKEN_ADDRESS } from '../config';
const abi = require('./abi/voy_token.json');

export function getVoyTokenContract(chainId, web3) {
    const instance = new web3.eth.Contract(
        abi,
        VOY_TOKEN_ADDRESS
    );
    return instance; 
}